import SetupClassTeacher from "components/module/setupClassTeacher"

const ClassSetupPage = () => {
  return <SetupClassTeacher variant="expense" />
}

export default ClassSetupPage
